import { render } from "./UpdateSiteInfo.vue?vue&type=template&id=33e892bd"
import script from "./UpdateSiteInfo.vue?vue&type=script&lang=js"
export * from "./UpdateSiteInfo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafedenj-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__